import Swiper from 'swiper';
import { EffectFade, Thumbs, Autoplay, Navigation } from 'swiper/modules';
import 'simplelightbox/dist/simple-lightbox.min.css';
import SimpleLightbox from 'simplelightbox';

const lightbox = new SimpleLightbox('.SingleProductContainer__gallery a', {});
const flexibleLightbox = new SimpleLightbox('.flexible-content a', {});

const thumbnailsSlider = new Swiper('.single-product-slider-thumbnails', {
    modules: [Autoplay],
    slidesPerView: 'auto',
    watchSlidesVisibility: true,
    spaceBetween: 10,
    autoplay: {
        delay: 5000,
    },
});

const singleProductSlider = new Swiper('.single-product-slider', {
    modules: [EffectFade, Thumbs, Navigation],
    effect: 'slide',
    thumbs: {
        swiper: thumbnailsSlider,
    },
    navigation: {
        nextEl: '.swiper-next-btn',
        prevEl: '.swiper-prev-btn',
    },
    autoHeight: true,
    loop: false,
    watchSlidesVisibility: true,
});
